import ReactInputMask from "react-input-mask";

import styled, { css } from "styled-components";

const backgroundColor = ({ theme }) => {
  return theme.colors.neutral.cinza900;
};

const disabledBackgroundColor = () => {
  return "rgba(186, 145, 227, 0.30)";
};

const placeHolderColor = ({ theme }) => {
  return theme.colors.neutral.cinza300;
};

const padding = ({ prefix, suffix }) => {
  return prefix || suffix ? "8px 16px 8px 0px" : "8px 12px";
};

const fontSize = ({ size }) => {
  switch (size) {
    case "xs":
      return "12px";
    case "sm":
      return "14px";
    case "lg":
      return "20px";

    case "md":
    default:
      return "16px";
  }
};

const outline = ({ state, theme }) => {
  switch (state) {
    case "success":
      return `1.5px solid ${theme.colors.feedbackState.success.default}`;
    case "warning":
      return `1.5px solid ${theme.colors.feedbackState.warning.default}`;
    case "error":
      return `1.5px solid ${theme.colors.feedbackState.critical.default}`;

    default:
      return `1px solid ${theme.colors.neutral.gray4}`;
  }
};

const focusBorderColor = ({ theme }) => {
  return theme.colors.primary.prim200;
};

const color = ({ disabled, theme }) => {
  if (disabled) return theme.colors.neutral.cinza600;

  return theme.colors.neutral.white;
};

export const Wrapper = styled.div`
  cursor: pointer;
  grid-area: ${({ gridArea }) => gridArea};
  margin: ${({ margin }) => margin}px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 8px;
  width: 100%;
  border: none;
  color: ${color};

  max-width: ${({ maxWidth }) => maxWidth || "auto"};
`;

export const HiddenInput = styled.input`
  display: none;
`;

export const Label = styled.label`
  display: block;
  font-size: ${fontSize};
  font-weight: ${({ theme }) => theme.font.weight.medium};
  line-height: 20px;
  letter-spacing: 0.02em;
  text-align: left;
  color: ${({ theme }) => theme.colors.neutral.white};
  font-family: ${({ theme }) => theme.font.fontFamily};
`;

export const InputWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  width: 100%;
  outline: ${outline};
  background-color: ${backgroundColor};
  /* border-radius: 4px; */
  /* border: 1px solid ${({ theme }) => theme.colors.neutral.cinza800}; */

  /* &:focus-within {
    outline: 1.5px solid ${focusBorderColor};
  } */

  ${({ disabled }) =>
    disabled &&
    css`
      cursor: not-allowed;
      opacity: 0.5;
    `}
`;

export const FileName = styled.div`
  padding: 0px 12px;

  span {
    color: ${({ theme }) => theme.colors.neutral.cinza500};
  }
`;

export const Files = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;

  padding: 0px 12px;

  width: 100%;
  max-width: 280px;
  overflow-x: auto;
`;

export const File = styled.div`
  padding: 5px;
  background-color: ${({ theme }) => theme.colors.neutral.cinza500};

  display: flex;
  align-items: center;
  justify-content: center;

  span {
    color: ${({ theme }) => theme.colors.neutral.white};
    font-size: 12px;
    margin: 0px;
  }
`;

export const RequiredDot = styled.span`
  display: inline-block;
  vertical-align: middle;
  margin-left: 2px;
  height: 4px;
  width: 4px;
  border-radius: 50%;
  background-color: ${({ theme }) =>
    theme.colors.feedbackState.critical.default};
`;

export const MaskedInputStyleStructure = styled(ReactInputMask)`
  padding: ${padding};
  background-color: ${backgroundColor};
  font-family: ${({ theme }) => theme.font.fontFamily};
  font-size: ${fontSize};
  border: none;
  /* border-radius: 4px; */
  width: 100%;
  &:focus {
    outline: none;
  }

  &:disabled {
    cursor: not-allowed;
    background-color: ${disabledBackgroundColor};
  }

  &::placeholder {
    color: ${placeHolderColor};
  }
`;

export const InputStylesStructure = styled.input`
  padding: ${padding};
  background-color: ${backgroundColor};
  font-size: ${fontSize};
  border: none;
  color: ${({ theme }) => theme.colors.neutral.white};
  width: 100%;
  &:focus {
    outline: none;
  }

  &:disabled {
    cursor: not-allowed;
    background-color: ${disabledBackgroundColor};
    height: 100%;
  }

  &::placeholder {
    color: ${placeHolderColor};
  }
`;
